import React from "react";
import { FormLayout } from "playground/cms/Form";
import Field from "containers/Field";
import { useData } from "state/hooks";
import { MediaField } from "playground/cms/fields/Media";

//import PropTypes from 'prop-types';

function PlanResources(props) {
    const {} = props;

    const { plan_type } = useData(props);

    const source = [3, 4].includes(plan_type)
        ? "api:apartments.floors"
        : "api:apartments.buildings";

    const label = [3, 4].includes(plan_type) ? "Piętro" : "Budynki";

    return (
        <Field
            id={"resources"}
            fieldType={"select"}
            label={label}
            source={source}
            multiple={true}
            nullable={true}
        />
    );
}

export function PlansForm(props) {
    const {} = props;
    return (
        <FormLayout.Fieldset pad>
            <Field id={"title"} label={"Nazwa"} />

            <Field
                id={"plan_type"}
                fieldType={"select"}
                label={"Typ planu"}
                source={"schema:data.plan-types"}
            />
            <PlanResources {...props} />
            <MediaField id={"media"} label={"Media"} />
        </FormLayout.Fieldset>
    );
}

PlansForm.propTypes = {};

PlansForm.defaultProps = {};

export default PlansForm;
